export default __webpack_public_path__ + "static/media/chevron_red-left.7d26f102.svg";